import {
  ChangeLogsList,
  Link,
  ChangeLogsListItem,
  ChangeLogsListItemDescription,
  StyledChangeLogsTile,
  ChangeLogsTileHeader,
  ChangeLogsListItemRepoName,
  VersionLabel,
  StyledVersion,
  ChangeLogsListMain,
  FavoriteButton,
  ItemActions
} from "./styled";
import { MdStarBorder, MdStar } from "react-icons/md";

export const ChangeLogsTile = ({
  list,
  tileHeader,
  versionType,
  favoriteKeys = [],
  onToggleFavorite = () => {},
  getItemKey = (item) => item?.id,
}) => {
  const groupedChanges = list.reduce((acc, item) => {
    const version = versionType === "currentVersion" ? "__ALL__" : item[versionType];
    if (!acc[version]) acc[version] = [];
    acc[version].push(item);
    return acc;
  }, {});

  return (
    <StyledChangeLogsTile>
      <ChangeLogsTileHeader>{tileHeader}</ChangeLogsTileHeader>
      <ChangeLogsListMain>
        {Object.keys(groupedChanges).map((version) => (
          <div key={version}>
            {version !== "__ALL__" && <StyledVersion>{version}</StyledVersion>}
            <ChangeLogsList>
              {groupedChanges[version].map((item) => {
                if (!item.description) return null;

                const itemKey = getItemKey(item);
                const isFavorite = favoriteKeys.includes(itemKey);

                return (
                  <ChangeLogsListItem key={itemKey}>
                    <ChangeLogsListItemRepoName>
                      {item.pamBuildVersionDev && <div><VersionLabel $variant="dev">DEV:</VersionLabel> {item.pamBuildVersionDev}</div>}
                      {item.pamBuildVersionBeta && <div><VersionLabel $variant="beta">BETA:</VersionLabel> {item.pamBuildVersionBeta}</div>}
                      {item.pamBuildVersion && <div><VersionLabel $variant="prod">PROD:</VersionLabel> {item.pamBuildVersion}</div>}
                      {!item.pamBuildVersion && !item.pamBuildVersionBeta && !item.pamBuildVersionDev && (
                        <div>Brak wersji</div>
                      )}
                    </ChangeLogsListItemRepoName>
                    <ChangeLogsListItemDescription
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                    <ItemActions>
                      <FavoriteButton
                        type="button"
                        onClick={() => onToggleFavorite(itemKey)}
                        $isFavorite={isFavorite}
                        title={isFavorite ? "Usuń z obserwowanych" : "Dodaj do obserwowanych"}
                        aria-label={isFavorite ? "Usuń z obserwowanych" : "Dodaj do obserwowanych"}
                      >
                        {isFavorite ? <MdStar /> : <MdStarBorder />}
                      </FavoriteButton>
                      {item.link ? (
                        <Link href={item.link} target="_blank" rel="noreferrer">Zobacz szczegoly</Link>
                      ) : (
                        <Link />
                      )}
                    </ItemActions>
                  </ChangeLogsListItem>
                );
              })}
            </ChangeLogsList>
          </div>
        ))}
      </ChangeLogsListMain>
    </StyledChangeLogsTile>
  );
};
